import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  // Sinal reativo para o status de conexão
  public $isOnline = signal<boolean>(navigator.onLine);

  constructor() {
    // Inicializa o serviço com o status atual de conexão
    this.setupListeners();
  }

  private setupListeners(): void {
    // Adiciona listeners para eventos de mudança de conectividade
    window.addEventListener('online', () => {
      this.$isOnline.set(true);
      this.syncOfflineData();
    });

    window.addEventListener('offline', () => {
      this.$isOnline.set(false);
    });
  }

  // Método para sincronizar dados quando voltar a ficar online
  private syncOfflineData(): void {
    // Este método será implementado posteriormente
  }
}
